import { createFileRoute, redirect } from '@tanstack/react-router';

import { paths } from 'src/routes/paths';

// The audit is no longer a standalone tab -- its judgment layer now lives inline
// on the analytics Overview (facts stay on the Campaigns tab). Kept as a redirect
// so existing links/bookmarks to /analytics/audit still resolve.
export const Route = createFileRoute(
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/audit',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: paths.dashboard.tenant(params.orgId, params.clientId).analytics,
    });
  },
});
